import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ReportParcelCountDiscrepancyDialogData {
    tourNumber?: string;
    consignmentNumber?: string;
    /** Expected / total goods count from the tour — shown as a reference next to the actual count input. */
    expectedGoods?: number | null;
}

export interface ReportParcelCountDiscrepancyDialogResult {
    actualCount: number;
    /** True when actualCount differs from expectedGoods and a discrepancy report should be sent. */
    hasDiscrepancy: boolean;
}

@Component({
    selector: 'app-report-parcel-count-discrepancy-dialog',
    templateUrl: './report-parcel-count-discrepancy-dialog.component.html',
    styleUrls: ['./report-parcel-count-discrepancy-dialog.component.scss'],
})
export class ReportParcelCountDiscrepancyDialogComponent {
    actualCount: number | null = null;

    constructor(
        public dialogRef: MatDialogRef<ReportParcelCountDiscrepancyDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ReportParcelCountDiscrepancyDialogData
    ) { }

    get hasDiscrepancy(): boolean {
        if (this.actualCount == null || this.data.expectedGoods == null) return false;
        return Number(this.actualCount) !== Number(this.data.expectedGoods);
    }

    cancel(): void {
        this.dialogRef.close(undefined);
    }

    confirm(): void {
        if (this.actualCount == null || Number.isNaN(Number(this.actualCount)) || Number(this.actualCount) < 0) {
            return;
        }
        const result: ReportParcelCountDiscrepancyDialogResult = {
            actualCount: Number(this.actualCount),
            hasDiscrepancy: this.hasDiscrepancy,
        };
        this.dialogRef.close(result);
    }
}
